import { LINKS } from "./links";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)]">
    <div className="container-x flex flex-col gap-8 px-6 py-12 md:flex-row md:items-center md:justify-between">
      <div>
        <p className="font-display text-lg">Intuitive Shoes</p>
        <p className="mt-1 text-sm text-[var(--ink-soft)]">
          Crowdsourced fit intelligence for footwear.
        </p>
      </div>
      <nav aria-label="Footer">
        <ul className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-[var(--ink-soft)]">
          <li>
            <a
              href={LINKS.APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-link-consumer-app"
              className="transition-colors duration-200 hover:text-[var(--ink)]"
            >
              Consumer App
            </a>
          </li>
          <li>
            <a href="#retailers" data-testid="footer-link-retailers" className="transition-colors duration-200 hover:text-[var(--ink)]">
              For Retailers
            </a>
          </li>
          <li>
            <a href="#how-it-works" data-testid="footer-link-how-it-works" className="transition-colors duration-200 hover:text-[var(--ink)]">
              How It Works
            </a>
          </li>
          <li>
            <a href={LINKS.PRIVACY_URL} data-testid="footer-link-privacy" className="transition-colors duration-200 hover:text-[var(--ink)]">
              Privacy
            </a>
          </li>
          <li>
            <button
              type="button"
              data-testid="footer-cookie-settings-btn"
              onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))}
              className="transition-colors duration-200 hover:text-[var(--ink)]"
            >
              Cookie Settings
            </button>
          </li>
        </ul>
      </nav>
    </div>
    <div className="border-t border-[var(--line)]">
      <div className="container-x flex flex-col gap-2 px-6 py-5 text-xs text-[var(--ink-soft)] md:flex-row md:justify-between">
        <span>Intuitive Shoes</span>
        <span>Fit intelligence built from real-world experience.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
